module.exports = __webpack_public_path__ + "img/icon-pdf.5743175.png";